import { observable, action } from 'mobx';
import * as services from '../services/production';
import { isDataExist } from 'utils/dataTools';
import { message, Modal } from 'antd';
import { omit,isEmpty } from 'lodash'
class Workorder {
  @observable isLoading = false;
  /* 列表 */
  @observable workSelectKeys = [];
  @observable workList = []
  @observable workPage = {pageIndex:1,pageSize:10}
  @observable deviceByList = []

  /* 弹窗 */
  @observable visible = false
  @observable status = ''
  @observable currentWork = {}
  @observable editInfo = {}

  @observable materialId = ''
  @observable deviceId = ''
  @observable procedureId = ''

  @observable formData = []

  /* 查询工单列表 */
  @action async getWorkList(data={}){
    this.isLoading = true;
    this.workList = []
		try {
			let params = {
				materialId:this.reportBomId || '',
				workNo: this.reportWorkId || '',
				deviceId: this.reportDevId || '',
        workStatus: this.workStatus,
        ...omit(this.workPage,'total'),
        ...data
			};
			let res = await services.gets('getWorkList')(params);
			this.isLoading = false;
			if(isDataExist(res)){
				this.workList = res.data.data.items;
				this.workPage = res.data.data.page;
			}
		} catch (error) {
			console.log(error);
		}
  }


	@action changeVisible = (visible)=>{
		this.visible = visible;
  }
  @action clearModal(){
		this.status = '';
    this.visible = false;
    this.workerId = '';
    this.currentWork = {}
  }
  @action clearData(){
    this.isLoading = false;
    /* 筛选条件 */
    this.plan_orderList = [];
    this.plan_bomList = [];
    this.reportBomId = '';
    this.reportDevId = '';
    this.reportWorkId = '';
    this.workStatus = '';
    this.report_deviceList = [];
    this.proceduresList = [];
    this.planByOrder = {};
    /* 列表 */
    this.workSelectKeys = [];
    this.workList = []
    this.workPage = {pageIndex:1,pageSize:10}
    this.deviceByList = []
  
    /* 弹窗 */
    this.visible = false
    this.status = ''
    this.currentWork = {}
    this.editInfo = {}
  
    this.materialId = ''
    this.deviceId = ''
    this.procedureId = ''
  }
}

let WorkorderStore = new Workorder();
export default WorkorderStore;
